"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("./utils");
var _constants = require("../../constants");
var _UploadSource = require("./UploadSource.styled");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils2 = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var UploadZone = function UploadZone(_ref) {
  var onFileChange = _ref.onFileChange,
    disabled = _ref.disabled;
  var inputFile = (0, _react.useRef)(null);
  var uploadZoneWrapper = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isFileDragOver = _useState2[0],
    setIsFileDragOver = _useState2[1];
  var handleButtonClick = function handleButtonClick() {
    inputFile.current.click();
    uploadZoneWrapper.current.focus();
  };
  var handleDrop = function handleDrop(event) {
    event.preventDefault();
    var droppedFiles = event.dataTransfer.files;
    setIsFileDragOver(false);
    onFileChange(droppedFiles, true);
  };
  var allowedExtensions = (0, _utils.getAllowedExtensions)();
  /** It is possible that the allowed extensions have extensions that we don't want to show in the UI. */
  var advertisedExtensions = allowedExtensions.filter(function (ext) {
    return !_constants.NOT_ADVERTISED_VIDEO_EXTS.includes(ext);
  }).join(', ');
  return /*#__PURE__*/_react["default"].createElement(_UploadSource.UploadZoneWrapper, {
    ref: uploadZoneWrapper,
    onDrop: handleDrop,
    onDragOver: function onDragOver(event) {
      event.preventDefault();
      setIsFileDragOver(true);
    },
    onDragEnter: function onDragEnter() {
      return setIsFileDragOver(true);
    },
    onDragLeave: function onDragLeave() {
      return setIsFileDragOver(false);
    },
    isFileDragOver: isFileDragOver,
    tabIndex: 0
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, "Drag files here to upload your own videos, images, and audio files.", /*#__PURE__*/_react["default"].createElement("br", null), advertisedExtensions, /*#__PURE__*/_react["default"].createElement("br", null), "(Limit to 5 files at a time and ", (0, _utils2.formatBytes)(_constants.SOURCE_MAX_FILE_SIZE), ' ', "per file)"), /*#__PURE__*/_react["default"].createElement(_UploadSource.HiddenInputFile, {
    "data-testid": "sourceFileInput",
    type: "file",
    "aria-labelledby": "sourceFileLabel",
    name: "file",
    multiple: true,
    onChange: function onChange(e) {
      return onFileChange(e.target.files, false);
    },
    id: "sourceFile",
    accept: allowedExtensions.join(', '),
    ref: inputFile
  }), /*#__PURE__*/_react["default"].createElement(_UploadSource.StyledButton, {
    disabled: disabled || isFileDragOver,
    onClick: handleButtonClick,
    "data-testid": "backgroundButtonInput",
    color: "light",
    type: "button"
  }, "Open file browser")));
};
UploadZone.propTypes = {
  onFileChange: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = UploadZone;